import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { defineStyles } from '../theme';
const styles = defineStyles({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    strongContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
});
export function ConfirmDialog({ open, strong, onCancel, onConfirm, title, content, confirmButtonText, confirmButtonColor, cancelButtonText, cancelButtonColor, }) {
    const [value, setValue] = useState('');
    const hasDeleteInInput = value.toLowerCase() === 'delete';
    return (_jsxs(Dialog, { open: open, onClose: onCancel, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { children: title }), _jsxs(DialogContent, { sx: styles.content, children: [content, strong && (_jsxs(Box, { sx: styles.strongContainer, children: [_jsx(Typography, { children: _jsx(FormattedMessage, { id: "confirmDialog.type_delete", defaultMessage: 'To confirm type "DELETE" in the box:' }) }), _jsx(TextField, { size: "small", value: value, onChange: (e) => setValue(e.target.value.toUpperCase()), error: !hasDeleteInInput })] }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onCancel, color: cancelButtonColor ?? 'error', children: cancelButtonText ?? _jsx(FormattedMessage, { id: "common.cancel.button", defaultMessage: "Cancel" }) }), _jsx(Button, { disabled: strong && !hasDeleteInInput, onClick: onConfirm, color: confirmButtonColor ?? 'primary', children: confirmButtonText ?? _jsx(FormattedMessage, { id: "common.ok.button", defaultMessage: "OK" }) })] })] }));
}
//# sourceMappingURL=ConfirmDialog.js.map